export default "__VITE_ASSET__9482b92a__"